import BaseDecorator from "./BaseDecorator";
import { generateUuid } from "lib/utils/socialtravel";

export default class CustomerDecorator extends BaseDecorator {
  static statuses = ["prospect", "future", "past", "lost"];

  static build(data = {}) {
    return new CustomerDecorator({
      id: null,
      uuid: generateUuid(),
      full_name: null,
      email: null,
      phone_number: null,
      company_note: null,
      ...data,
    });
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/CustomerDecorator.js